export default () => {
  
  document.addEventListener('DOMContentLoaded', function () {
    var navOpenElements = document.querySelectorAll('[data-controller="mobile-nav-open"]');

    navOpenElements.forEach(function (element) {
      // The component library header wires its own menus to its Stimulus
      // controller; binding them here too would toggle them twice per click.
      if (element.hasAttribute('data-action')) return;

      var target = element.querySelector('[data-mobile-nav-open-target="target"]');
      var arrowbutton = element.querySelector('[data-mobile-nav-open-target="arrowbutton"]');

      if (!target || !arrowbutton) return;

      element.addEventListener('click', function (e) {
        if (window.innerWidth < 1024) {
          // e.preventDefault();
          // e.stopPropagation();
          target.classList.toggle('open');
          arrowbutton.classList.toggle('rotate');
        }
      });
    });
  });

};
